import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    width: '100%',
    height: '35vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  icon: {
    color: theme.palette.font.secondary,
  },
  text: {
    color: theme.palette.font.primary,
    textAlign: 'center',
    fontSize: '30px !important',
  },
  title: {
    color: theme.palette.font.primary,
    textAlign: 'center',
  },
  description: {
    color: theme.palette.font.secondary,
    textAlign: 'center',
    marginTop: theme.spacing(1),
  },
}));

export default useStyles;
